import { api } from "@/lib/axios";
import { Type } from "@/types/lead";

const get = (): Promise<Type[]> =>
    api.get("/types").then((r) => r.data);

export default get;
